export const settings = {
    baseServingSize: 8,
    servingSizes: [8, 16]
}